<template>
  <section class="fullscreen">
    <div class="container">
      <div class="fullscreen-body">
        <h1>Лучшее для лучших</h1>
        <div class="buttons">
          <router-link :to=" { name: 'Projects' } " class="button__transparent button_middle btn">Проекты</router-link>
          <button class="button__transparent button_middle btn" @click="plusCalc">Расчитать стоимость</button>
        </div>
      </div>
      <img src="../../public/static/icons/arrow-down.svg" alt="" class="arrow">
    </div>
    <div class="fullscreen-bg">
      <div class="fullscreen-bg__shadow"></div>
      <picture>
        <source srcset="../../public/static/images/sectionFirstScreen/1.webp">
        <img src="../../public/static/images/sectionFirstScreen/1.jpg" alt="">
      </picture>
    </div>
  </section>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  name: 'SectionFullscreen',
  components: {},
  methods: {
    ...mapActions(['calcStatusPlus']),
    plusCalc () {
      this.calcStatusPlus()
    }
  },
  computed: {},
  mounted() {
  }
}
</script>

<style scoped lang='scss'>
.fullscreen {
  position: relative;
  width: 100%;
  height: 94vh;
  min-height: 94vh;
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    .arrow {
      position: absolute;
      bottom: 10%;
      animation-name: anim-arrow;
      animation-duration: 2s;
      animation-iteration-count: infinite;
    }
  }
  &-body {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 2vh;
    h1 {
      font-weight: 300;
      color: #fff;
      margin-bottom: 10rem;
      @media (max-width: 575.98px) {
        font-size: 4rem;
        margin-bottom: 2rem;
      }
    }
    .buttons {
      display: flex;
      justify-content: space-between;
      width: 100%;
      @media (max-width: 575.98px) {
        flex-wrap: wrap;
      }
      .btn {
        border-color: #fff;
        color: #fff;
        background-color: rgba(0,0,0,.4);
        padding: 24px 10px;
        display: inline-flex;
        box-sizing: border-box;
        line-height: 145%;
        flex: 0 0 48%;
        max-width: 48%;
        @media (max-width: 575.98px) {
          flex: 1 1 100%;
          max-width: 100%;
          margin-bottom: 20px;
          padding: 10px 10px;
        }
      }
    }
  }
  &-bg {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center;
    }
    &__shadow {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background-color: #000;
      opacity: .4;
    }
  }
}
@keyframes anim-arrow {
  0% {
    opacity: .6;
    transform: translateY(-3px);
  }
  50% {
    opacity: 1;
    transform: translateY(3px);
  }
  100% {
    opacity: .6;
    transform: translateY(-3px);
  }
}
</style>
